module.exports = __webpack_public_path__ + "static/media/correct.0f8e0134.svg";